import { defineComponent as _defineComponent } from 'vue'
import InterfaceFocusedLayoutModeSvg from './InterfaceFocusedLayoutMode.svg';
import NormalFlowTreeModeSvg from './NormalFlowTreeMode.svg';

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutModeSwitch',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: boolean): void }), expose: any, slots: any, attrs: any }) {



const setInput = (value: boolean) => emit('input', value);

return { __sfc: true,emit, setInput, InterfaceFocusedLayoutModeSvg, NormalFlowTreeModeSvg }
}

})